module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_025.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_025.png
// module id = 2341
// module chunks = 5